import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { Router } from '@angular/router';

export interface Profile {
  title: string;
  childs: Array<{ title: string; link: string }>;
  icon: string;
  description: string;
}

@Component({
  selector: 'fcp-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  @Input() public data: any;
  @Output() public openModal: EventEmitter<any> = new EventEmitter();
  @Output() public openModalCredential: EventEmitter<any> = new EventEmitter();

  constructor(private router: Router) {}

  ngOnInit() {
  }

  openWindow(url: string) {
    const w = 650;
    const h = 650;
    const dualScreenLeft = window.screenLeft
      ? window.screenLeft
      : window.screenX;
    const dualScreenTop = window.screenTop ? window.screenTop : window.screenY;
    const width = window.innerWidth
      ? window.innerWidth
      : document.documentElement.clientWidth
      ? document.documentElement.clientWidth
      : screen.width;
    const height = window.innerHeight
      ? window.innerHeight
      : document.documentElement.clientHeight
      ? document.documentElement.clientHeight
      : screen.height;
    const systemZoom = width / window.screen.availWidth;
    const left = (width - w) / 2 / systemZoom + dualScreenLeft;
    const top = (height - h) / 2 / systemZoom + dualScreenTop;
    const newWindow = window.open(
      url,
      'chat',
      'scrollbars=yes, status=no, toolbar=no, location=no, directories=no, menubar=no, resizable=no, fullscreen=no, width=' +
        w +
        ', height=' +
        h +
        ', top=' +
        top +
        ', left=' +
        left
    );
    if (window.focus) newWindow.focus();
  }

  actionCall(route, url, button) {
    if (route) {
      this.router.navigate([route]);
    } else if (url) {
      if (button && button[0].openUrl === 'Janela pop-up') {
        this.openWindow(url);
      } else if (button && button[0].openUrl === 'Mesma aba') {
        window.location = url;
      } else {
        window.open(url, '_blank');
      }
    }
  }

  clickModal(value: any) {
    this.openModal.emit(value);
  }
}
